var $df57f3dfdac40a9a$exports = {};
$df57f3dfdac40a9a$exports = {
    "maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "minimum": `\u{41C}\u{438}\u{43D}\u{438}\u{43C}\u{443}\u{43C}`
};


export {$df57f3dfdac40a9a$exports as default};
//# sourceMappingURL=ru-RU.module.js.map
